import React from "react";
import { Box, Container, Button } from "@mui/material";
import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
  from { 
    opacity: 0;
    transform: translateY(30px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
`;

const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: 1;
`;

const HeroSection = styled(Box)`
  color: #ffffff;
  padding: 0;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2;
  }
`;

const ContentWrapper = styled(Container)`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  margin: 0 auto;
  padding: 0 24px;
  gap: 24px;
`;

const MainTitle = styled.h1`
  font-size: 4.5rem;
  line-height: 1.2;
  margin-bottom: 20px;
  color: #ffffff;
  font-weight: 800;
  letter-spacing: -0.02em;
  text-align: center;
  max-width: 900px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  animation: ${slideUp} 0.8s ease-out;

  @media (max-width: 1024px) {
    font-size: 3.5rem;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
    padding: 0 16px;
  }
`;

const SubTitle = styled.p`
  font-size: 1.5rem;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 32px;
  max-width: 700px;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-weight: 500;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    padding: 0 16px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    padding: 0 16px;
  }
`;

const StyledButton = styled(Button)`
  && {
    padding: 12px 32px;
    font-size: 1.125rem;
    font-weight: 600;
    text-transform: none;
    border-radius: 8px;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.9);
    color: #000000;
    border: none;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    &:hover {
      transform: translateY(-2px);
      background: #ffffff;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    }

    @media (max-width: 768px) {
      width: 100%;
      margin: 0;
    }
  }
`;

const Hero = () => {
  return (
    <HeroSection>
      <VideoBackground
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        webkit-playsinline="true"
      >
        <source src="/video/boxes.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </VideoBackground>
      <ContentWrapper maxWidth="xl">
        <MainTitle>Power Your Dropshipping Business</MainTitle>
        <SubTitle>
          Start your e-commerce journey with our powerful dropshipping solution
        </SubTitle>
        <ButtonGroup>
          <StyledButton
            variant="contained"
            onClick={() =>
              window.open("https://apps.shopify.com/dropship-india", "_blank")
            }
          >
            Link Your Store
          </StyledButton>
        </ButtonGroup>
      </ContentWrapper>
    </HeroSection>
  );
};

export default Hero;
